export default __webpack_public_path__ + "static/media/merchant.0e113d14.svg";